var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._v(" 好看鸭技术支持介绍长图页 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }